// extracted by mini-css-extract-plugin
module.exports =  {"HeadingWithId":"HeadingWithId__jpRTc","subtitleWithId":"subtitleWithId__-qGZX"};